import Logger from "../../Logger";
import Consumer from "../../models/Consumer";
import { stringToShortKey } from "../../models/utils";
import localStorageHandler from "../../persistence/LocalstorageHandler";
import ServerDataBaseHandler from "../../persistence/SeverDataBaseHandler";
import universalstorageHandler from "../../persistence/UniversalstorageHandler";
import { cleanEncode } from "../../utils/CommonUtils";
import PanelDevice from "./PanelDevice";
import { PanelKnxSignal } from "./PanelKnxSignal";
const logger = new Logger();

import PanelSitemap from "./PanelSitemap";

export class PanelData {
  /////////////////////////////////////////////////////////////
  // persistent data

  pin = "";

  enableEdit = false;

  projectId: string = "";
  projectName: string = "";

  items = new Map<string, PanelDevice>();

  sitemaps = new Array<PanelSitemap>();

  config = {
    showFavorits: false,
    showSettings: true,
    showCameras: false,
    sitemaps: [
      {
        name: "",
        label: "",
        icon: "",
      },
    ],
  };

  dataPointLoadingIsRunning = false;
  private registerDatapointsPromise: Promise<void> | undefined;
  private registerDatapointsInstallationPromise: Promise<void> | undefined;

  ////////////////////////////////////////////////////////////////////////////////////

  getItem(id: string): any {
    return this.items.get(id);
  }

  getItemByName(persistName: string) {
    var res: any = null;
    this.items.forEach((item) => {
      if (item.name == persistName) {
        if (item.type == "Switch") {
          res = { item: item, property: "SwitchStatus" }; // no itx
        } else {
          res = { item: item, property: "value" }; // no itx
        }
      }
    });
    return res;
  }

  getItemByReceiveGroupAdress(
    groupAddress: string,
  ): { item: PanelDevice; property: string; signal: PanelKnxSignal } | undefined {
    var res;

    this.items.forEach((item) => {
      const knx = item.knx;
      if (knx) {
        for (const name in item.knx) {
          const signal = (item.knx as any)[name];
          if (signal) {
            if (signal.ga === groupAddress) {
              res = { item: item, property: name, signal: signal };
            }
          }
        }
      }
    });
    return res;
  }

  getItemByConsumer(consumer: Consumer): PanelDevice | undefined {
    for (let [key, item] of this.items) {
      if (item.consumer == consumer) {
        return item;
      }
    }
    return undefined;
  }

  getSiteMaps = () => {
    return this.sitemaps;
  };
  getAllSitemaps = (): Array<PanelSitemap> => {
    return this.sitemaps;
  };

  getSitemap = (name: string) => {
    console.log("getSitemap " + name);
    for (const i in this.sitemaps) {
      const item = this.sitemaps[i];
      if (item.name === name) {
        return item;
      }
    }
    return null;
  };

  // async  loadSitemaps(sitemapNamesX: string, allDevices: Array<any>) {
  //   console.log("loadSitemaps");
  //   const sitemapNames = sitemapNamesX.split("\n");
  //   const newSitemaps = [];
  //   for (const i in sitemapNames) {
  //     const sitemapName = sitemapNames[i].trim();

  //     if (sitemapName != "") {
  //       const response = await fetch("/data/sitemaps/" + sitemapName);
  //       const sitemap: PanelSitemap = await response.json();

  //       console.log("process sitemap " + sitemapName);

  //       sitemap.rooms.map((room) => {
  //         const newItems =   new  Array<any>();
  //         room.items.map((i1) => {
  //           const item1 = this.getItem(i1.item);
  //           if (item1) {
  //             newItems.push({ device: item1, label: i1.label });
  //             console.log(item1.Name + " -- " + i1.label);
  //           }
  //           // return null;
  //         });
  //         room.items = newItems;
  //         // return null;
  //         sitemap.rooms.push(room);
  //       });

  //       // return null;
  //       newSitemaps.push(sitemap);
  //     }
  //   }
  //   this.sitemaps = newSitemaps;
  // }

  // async  xLoadItems(itemNamesX) {
  //   console.log("loadItems " + itemNamesX);
  //   const itemsNames = itemNamesX.split("\n");

  //   for (const i in itemsNames) {
  //     const itemName = itemsNames[i].trim();

  //     if (itemName != "") {
  //       const response = await fetch("/data/items/" + itemName);
  //       const itemsPart = await response.json();
  //       itemsPart.items.forEach((item) => {
  //         items.add(new PanelDevice(item));
  //       });
  //     }
  //   }
  // }

  async loadPersistentData(startDate: Date, items: Array<string>) {
    try {
      var s = items.join(";");
      s = cleanEncode(s);

      const month = startDate.getMonth() + 1;
      const year = startDate.getFullYear();

      const socketServer = localStorage.getItem("webSocketServer");

      const response = await fetch(`http://${socketServer}/getPersitentData?names=${s}&year=${year}&month=${month}`);

      if (response.ok) {
        const json = await response.json();
        return json;
      } else {
        return null;
      }
    } catch (ex) {
      return null;
    }
  }

  runsOnMainPanel() {
    return (
      window.location.host.toLowerCase().indexOf("localhost") >= 0 &&
      window.location.search.toLowerCase().indexOf("dev") < 0
    );
  }

  registerDatapoints() {
    if (this.registerDatapointsPromise) return this.registerDatapointsPromise;

    const promise = this.registerDatapointsCore();
    this.registerDatapointsPromise = promise.finally(() => {
      this.registerDatapointsPromise = undefined;
    });
    return this.registerDatapointsPromise;
  }

  private async registerDatapointsCore() {
    try {
      this.dataPointLoadingIsRunning = true;
      var dataPoints = new Array<any>();
      this.items.forEach((item) => {
        if (item.knx) {
          for (let signalName in item.knx) {
            const signal = (item.knx as any)[signalName] as PanelKnxSignal;
            let persistent = false;
            if (signalName == "temperatur") {
              persistent = true;
            }

            let dpst = signal.dpt.toLocaleUpperCase();
            if (!dpst.startsWith("DPST")) {
              dpst = "DPST-" + dpst;
            }

            var p = "";
            if (persistent) {
              p = ",p"; // no itx
            }

            dataPoints.push(signal.ga + "," + dpst + p);
          }
        } else {
          dataPoints.push(item.name);
        }
      });

      var s = dataPoints.join(";");

      await (window as any).websocketIsOpen();

      (window as any).sendToSocketServer({ command: "loadDatapoints", data: s }); // no itx
    } catch (ex) {
      console.error(ex);
    }

    this.dataPointLoadingIsRunning = false;
  }

  registerDatapointsInstallation() {
    if (this.registerDatapointsInstallationPromise) return this.registerDatapointsInstallationPromise;

    const promise = this.registerDatapointsInstallationCore();
    this.registerDatapointsInstallationPromise = promise.finally(() => {
      this.registerDatapointsInstallationPromise = undefined;
    });
    return this.registerDatapointsInstallationPromise;
  }

  private async registerDatapointsInstallationCore() {
    try {
      var dataPoints = new Array<any>();
      state.allGroupAddresses(true).forEach((ga) => {
        let dpst = ga.dpt.toLocaleUpperCase();
        if (!dpst.startsWith("DPST")) {
          dpst = "DPST-" + dpst;
        }
        dataPoints.push(ga.fullAddress + "," + dpst);
      });

      var s = dataPoints.join(";");

      await (window as any).websocketIsOpen();

      (window as any).sendToSocketServer({ command: "loadDatapoints", data: s }); // no itx
    } catch (ex) {
      console.error(ex);
    }

    this.dataPointLoadingIsRunning = false;
  }

  lastPing = null;
  onPing = (dataFromServer: any) => {
    this.lastPing = dataFromServer;

    this.showError({ message: "KNX Online" }); // no itx

    // state.knxState.value = "active";
    // state.knxStateText.value = "";
  };

  showError = (dataFromServer: any) => {
    try {
      if (dataFromServer.errorCode) {
        logger.error(`Error from Bridge: ${dataFromServer.errorCode} ${dataFromServer.message}`);

        state.knxState.value = "error";
        state.knxStateText.value = dataFromServer.message;
      } else {
        logger.log(`Message from Bridge: ${dataFromServer.message}`);

        state.knxState.value = "active";
        state.knxStateText.value = dataFromServer.message;
      }
    } catch (ex) {
      console.error(ex);
    }
  };

  onConnect = (dataFromServer: any) => {};

  onKnxReceived = (dataFromServer: any) => {
    logger.log("onKnxReceived... " + dataFromServer.groupAddress + " = " + dataFromServer.value);

    if (state.installationMode && dataFromServer.groupAddress) {
      const ga = state.getGroupAddress(dataFromServer.groupAddress);
      if (ga) {
        ga.currentValue = dataFromServer.value;
        ga.receivedTimeStamp = new Date();
        ga.receivedCount = (ga.receivedCount || 0) + 1;
        delete ga.sendTimeStamp;
        ga.raiseOnChange("currentValue");
      }
    }

    const xitem = this.getItemByReceiveGroupAdress(dataFromServer.groupAddress);
    if (xitem) {
      const { item, property, signal } = xitem;
      // console.log(`item found ${item.name} ${property}`);
      item.gotDataFromServer(dataFromServer.groupAddress, dataFromServer.value, property);
    }
  };

  onVarChanged = (dataFromServer: any) => {
    logger.log("onVarChanged... " + dataFromServer.varname + " = " + dataFromServer.value);

    const device = this.getItem(dataFromServer.varname);

    var property = "value"; // no itx
    if (device) {
      if (device.type === "switch") {
        property = "SwitchStatus"; // no itx
      }
      device.gotDataFromServer(dataFromServer.varname, dataFromServer.value, property);
    }
  };

  loadCurrentState = () => {
    const socketServer = localStorage.getItem("webSocketServer");

    const url = "http://" + socketServer + "/getCurrentState";
    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const lines = text.split("\n");
        for (let i = 0; i < lines.length; i++) {
          const line = lines[i];
          const columns = line.split(";");
          const groupAddress = columns[0];

          const v = columns[1];
          let xitem: any = null;

          if (groupAddress.startsWith("persist:")) {
            xitem = this.getItemByName(groupAddress);
          } else {
            xitem = this.getItemByReceiveGroupAdress(groupAddress);
          }

          if (xitem) {
            const { item, property } = xitem;
            item.gotDataFromServer(groupAddress, v, property);
          }
        }
      });
  };

  // loadItems = async () => {
  //   try {
  //     var response = await fetch("/data/items/all.txt");
  //     var data = await response.text();
  //     console.log("items loaded");
  //     await this.xLoadItems(data);

  //     if (this.runsOnMainPanel()) {
  //       (window as any).websocketIsOpen().then(() => {
  //         console.log("registerDatapoints");
  //         this.registerDatapoints(data);
  //         console.log("registerDatapoints done");
  //       });
  //     } else {
  //       this.loadCurrentState();
  //     }

  //     /////////////////////////////////////////////////////////

  //     console.log("mwe 123 " + items.size);

  //     response = await fetch("/data/sitemaps/all.txt");
  //     data = await response.text();
  //     console.log("sitemaps/all.txt loaded");
  //     await this.loadSitemaps(data, items);
  //   } catch (ex) {
  //     console.error("loading items failed", ex);
  //     logger.error({ label: "Error connecting " + window.server });
  //   }
  // };

  toJSON = (): any => {
    const jItems = new Array<any>();
    this.items.forEach((item) => {
      jItems.push(item.toJSON());
    });

    return {
      lastModified: new Date(),
      id: "_panel_",
      projectId: this.projectId,
      projectName: this.projectName,
      pin: this.pin,

      sdata: JSON.stringify({
        items: jItems,
        config: this.config,
        sitemaps: this.sitemaps,
      }),
    };
  };

  fromJSON(data: any): void {
    this.projectName = data.projectName;
    this.projectId = data.projectId;
    this.pin = data.pin;

    const data1 = JSON.parse(data.sdata);

    this.config = data1.config;
    this.sitemaps = data1.sitemaps;

    this.items = new Map<string, PanelDevice>();

    data1.items.forEach((jItem: any) => {
      const item = new PanelDevice(jItem);
      item.id = jItem.id;
      this.items.set(item.id, item);
    });
  }

  async saveToServer(): Promise<string> {
    const key = stringToShortKey(this.projectId);
    this.pin = key;

    await (universalstorageHandler.storageHandler as ServerDataBaseHandler).savePanelData(
      `Panel-${key}`,
      JSON.stringify(this.toJSON()),
    );

    return key;
  }

  async LoadFromServer(key: string): Promise<boolean> {
    try {
      if (!state.isLoggedIn) {
        const user = state.loggedInUser;
        await universalstorageHandler.login(user);
      }

      const sdata = await (universalstorageHandler.storageHandler as ServerDataBaseHandler).loadPanelData(
        `Panel-${key}`,
      );

      if (sdata) {
        const data = JSON.parse(sdata);
        this.fromJSON(data);
        return true;
      }
    } catch (ex) {
      console.error(ex);
    }

    return false;
  }

  async saveToLoacalStorage() {
    await localStorageHandler().saveProjectMetadata("", this.toJSON());
  }

  async loadFromLoacalStorage() {
    try {
      const data = await localStorageHandler().loadProjectMetadata("_panel_"); // no itx
      if (data) {
        this.fromJSON(data);
      }
    } catch (ex) {
      console.error(ex);
    }
  }

  initCallbacks() {
    (window as any).onVarChanged = this.onVarChanged;
    (window as any).onKnxReceived = this.onKnxReceived;
    (window as any).onPing = this.onPing;
    (window as any).showError = this.showError;
    (window as any).onConnect = this.onConnect;
  }
}

export const globalPanelData = new PanelData();
